import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import SponsoredCohortQuizAnalytics from '../components/SponsoredCohortQuizAnalytics';
import SponsoredCohortQuizResultsRawData from '../components/SponsoredCohortQuizResultsRawData';

const TABS = [
  { title: 'Quiz analytics', component: <SponsoredCohortQuizAnalytics /> },
  {
    title: 'Quiz results raw data',
    component: <SponsoredCohortQuizResultsRawData />,
  },
];

function CohortQuizAnalytics() {
  return (
    <AnalyticsPageLayout
      title="Cohort Quiz Analytics"
      description="Quiz submissions and performance by gender and cohort."
      tabs={TABS}
    />
  );
}

export default CohortQuizAnalytics;
